query getELearningPrice($assignmentId: String!) {
  getELearningPrice(assignmentId: $assignmentId) {
    salesPrice {
      feeElearning
      currency
    }
  }
}
